import React from "react";
import { Reveal, Stagger, StaggerItem } from "../../lib/motion";
import { useApp } from "@/context/AppContext";

export default function Industries() {
  const { t } = useApp();
  const list = t("industries.list") || [];
  return (
    <section id="industries" data-testid="industries-section" className="relative py-20 md:py-28">
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-[11px] tracking-[0.24em] uppercase text-black/75 mb-4 font-bold">
            {t("industries.eyebrow")}
          </p>
          <h2 className="font-display font-black text-black leading-[1.02] tracking-tight text-4xl md:text-5xl lg:text-6xl">
            {t("industries.title1")} <span className="text-black/55">{t("industries.title2")}</span>
          </h2>
          <p className="mt-5 max-w-2xl text-black/80 text-base md:text-lg leading-relaxed">
            {t("industries.sub")}
          </p>
        </Reveal>
        <Stagger className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {list.map((i) => (
            <StaggerItem key={i.name}>
              <div
                data-testid={`industry-${i.name.toLowerCase().replace(/\s+/g,"-")}`}
                className="h-full rounded-2xl p-6 bg-white/70 backdrop-blur border border-black/10 hover:border-black/30 hover:-translate-y-0.5 transition-all"
              >
                <div className="text-[11px] tracking-[0.2em] uppercase text-black/60 font-bold mb-2">
                  Industry
                </div>
                <h3 className="font-display font-black text-2xl text-black tracking-tight">{i.name}</h3>
                <p className="mt-3 text-black/75 text-[14px] leading-relaxed">{i.items}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
